export { default } from './svg/group.svg';
